// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"; // For authentication
import { getDatabase } from "firebase/database"; // For Realtime Database

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCVnuMLDhLhWgi4fr-Stg0MTNUpKtyAE5s",
  authDomain: "form-builder-2025.firebaseapp.com",
  databaseURL: "https://form-builder-2025-default-rtdb.firebaseio.com",
  projectId: "form-builder-2025",
  storageBucket: "form-builder-2025.firebasestorage.app",
  messagingSenderId: "412676240060",
  appId: "1:412676240060:web:20ebb880951a7fac27d6b9",
  measurementId: "G-36MNM65Q2R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app); // Initialize Firebase Authentication
const realTimeDb = getDatabase(app); // Initialize Realtime Database

// Export the Firebase services
export { app, analytics, auth, realTimeDb };
